import { Illustration, Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

interface EmptyProps {
  title?: string;
  description?: string;
  buttonTitle?: string;
  onPressButton?: () => void;
}

export const Empty: React.FC<EmptyProps> = ({
  title = 'Você não possui itens adicionados',
  description = 'Você ainda não possui item adicionados\nna lista, volte e adicione novos itens.',
  buttonTitle,
  onPressButton,
}) => {
  return (
    <VStack alignItems="center" justifyContent="center" flex={1} space={Spacing['inline.xxxs']}>
      <Illustration name="NotEmptyIllustration" testID="empty-illustration" />
      <VStack space={Spacing['inline.quarck']}>
        <Text
          color="neutral.black"
          variant="bold"
          textAlign={'center'}
          fontSize={Typography['fontsize.md']}>
          {title}
        </Text>
        <Text color="neutral.black" textAlign="center">
          {description}
        </Text>
        {buttonTitle && onPressButton && (
          <Pressable testID="button-action-item-empty" alignSelf="center" onPress={onPressButton}>
            <Text
              color={'brand.tertiary.principal'}
              variant="semibold"
              fontSize={Typography['fontsize.md']}>
              {buttonTitle}
            </Text>
          </Pressable>
        )}
      </VStack>
    </VStack>
  );
};
